<template>
  <div class="section-container">
    
    <div class="section-header">
      <h1 class="section-title">
        Almacén
      </h1>
      <div class="section-filter">
        <v-text-field
          class="section-search"
          hide-details
          placeholder="Buscar"
          single-line
          v-model="currentSearch"
          clearable
          @click:clear="clearSearch">
          <template v-slot:append>
            <unicon name="search" fill="#5A5A5A"></unicon>
          </template>
        </v-text-field>
        <div class="section-filter-down">

          <v-btn
            style="margin-right: 20px;  margin-top: 15px;"
            color="purple"
            text
            rounded
            @click="exportExcel"> 
            Descargar Registros
            <unicon name="cloud-download" fill="#7954C2"></unicon>
          </v-btn>

          <div class="section-filter-element">
            <span>Tipo:</span>
            <v-select
              class="select-filter"
              dense
              v-model="select_filter_type"
              :items="filter_type"
              item-text="text"
              item-value="value">
            </v-select>
          </div>

          <div class="section-filter-element">
            <span>POS:</span>
            <v-select
              class="select-filter"
              dense
              v-model="selected_filter_pos"
              :items="filter_pos"
              item-text="text"
              item-value="value">
            </v-select>
          </div>
        </div>
      </div>
    </div>    

    <div class="section-table"
      style="background-color: white; display: flex; flex-direction: row;">
      <span style="margin: 20px;">Desde: </span>
      <div style="width: 250px; margin-left: 15px;">
        <v-menu
          ref="showDPS"
          v-model="showDPS"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dateFormattedStart"
              readonly
              class="input-datapicker-table"
              persistent-hint
              v-bind="attrs"
              v-on="on"/>
          </template>
          <v-date-picker
            v-model="dateStart"
            no-title
            color="primary"
            @change="dateSelected"
            @input="showDPS = false"/>
        </v-menu>
      </div> 
      <span style="margin: 20px;">Hasta: </span>
      <div style="width: 250px; margin-left: 15px;">
        <v-menu
          ref="showDPE"
          v-model="showDPE"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dateFormattedEnd"
              readonly
              class="input-datapicker-table"
              persistent-hint
              v-bind="attrs"
              v-on="on"/>
          </template>
          <v-date-picker
            v-model="dateEnd"
            no-title
            color="primary"
            @change="dateSelected"
            @input="showDPE = false"/>
        </v-menu>
      </div>      
    </div>

    <div class="section-table">
      <v-data-table
        :headers="headers"
        :items="stock"
        :items-per-page="stock.length"
        hide-default-footer>
        <template #item="{ item }">
          <tr>
            <td>{{ formattedDate(item.createdAt)}}</td>
            <td>{{ formattedType(item.type)}}</td>
            <td>{{ item.product_sku}}</td>
            <td>{{ item.product_name}}</td>
            <td>{{ item.quantity}}</td>
            <td>${{ item.cost}}</td>
            <td>${{ item.quantity * item.cost}}</td>
            <td>{{ item.terminal_id.name}}</td>


            <td @click="openDialogProduct(item)" >
              <unicon
                style="cursor: pointer;"
                name="edit"
                fill="#5A5A5A"/>

                 <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" style="cursor: pointer;">
                      <unicon
                        name="comment-add"
                        :fill="item.note !== '' ? '#FFA500' : '#5A5A5A'"
                      />
                    </span>
                  </template>
                  <span>{{ item.note }}</span>
                </v-tooltip>


            </td>

           

           
          </tr>
        </template>
      </v-data-table>
      <div v-if="showBtnMore"  class="btnMoreData" >
        <span @click="getStock(true)">Mostrar mas +</span>
      </div>
    </div>

    

   
    <floating-button 
      @clickFloating="openDialogProduct(null)" 
      icon="add" color="black"/>


      <add-edit-stock-modal  
      ref="addEditModal" 
      :terminals="terminals"/>

  </div>
</template>


<script>
import axios from 'axios'
import FloatingButton from './Toolbars/FloatingButton'
import { format, parseISO } from 'date-fns'
import * as XLSX from "xlsx/xlsx.mjs";
import userApi from './../api/userApi';
import AddEditStockModal from './Dialogs/AddEditStockModal.vue'
export default {
  name: 'CyphraWebStock',
  components: { 
    FloatingButton,
    AddEditStockModal
  },
  Comment:{},
  data() {
    return {
      dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      showDPS: false,
      showDPE: false,

      
      currentSearch: '',
      select_filter_type: "all",
      selected_filter_pos: "todos",
      filter_type: [
        { value: 'all', text: 'Todos' },
        { value: 'in', text: 'Entrada' },
        { value: 'out', text: 'Salida' },
      ],
      filter_pos: [
        { value: 'todos', text: 'Todos' },
      ],
      headers: [
        { text: 'Fecha', value: 'createdAt' },
        { text: 'Tipo', value: 'type' },
        { text: 'Sku', value: 'product_sku' },
        { text: 'Producto', value: 'product_name' },
        { text: 'Unidades', value: 'quantity' },
        { text: 'Costo U.', value: 'cost' },
        { text: 'Total', value: 'total' },
        { text: 'POS', value: 'pos' },
        { text: 'Acciones', value: 'actions' },
        
      ],
      terminals:[],
      stock: [],
      businessId:"",
      currentPage:1,
      totalPage:0, 
      showBtnMore:false
    };
  },
  watch: {
    selected_filter_pos(newVal, oldVal) {
      this.getStock(false)  
    },
    select_filter_type(newVal, oldVal) {
      this.getStock(false)  
    },
    currentSearch(newVal, oldVal) {
      this.getStock(false)  
    },
  },
  created () {
    this.loadListeners();
  },
  mounted() { 
    this.getInfo();
  },
  computed: {
    dateFormattedStart () {
      return this.dateStart ? this.dateHelpers.formatInput(this.dateStart) : ''
    },
    dateFormattedEnd () {
      return this.dateEnd ? this.dateHelpers.formatInput(this.dateEnd) : ''
    },
  },
  methods: { 
    openDialogProduct(item) {
        this.terminals = [...this.filter_pos]
        this.terminals.shift()
        this.$refs.addEditModal.open(item,this.businessId)
    },
    
    clearSearch() {
      this.currentSearch = '';
      this.getStock(false); // Ejecuta la función al limpiar el campo
    },

    dateSelected(date){
      this.getStock(false)
      console.log( this.dateStart);
      console.log( this.dateEnd);
    },

    formatCurrency(value) {
      if (!value) return '0.00';
        return new Intl.NumberFormat('es-MX', {
            style: 'currency', 
            currency: 'MXN',  
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    },

    loadListeners () {
      this.$bus.$off('refreshList');
      this.$bus.$on('refreshList', (isLoading) => {  
        this.getInfo();
      });
    },

    async getInfo(){
      const me = this
      me.stock=[]
      const userData = this.$store.state.user
      if(userData.role == "admin"){
        const userResponse = await userApi.getUser(userData._id);
        me.businessId = userResponse.data.business
      }else{
        me.businessId = (this.$store.state.business)._id
      }
      me.getPostList(me.businessId)
    },

    getPostList(bussinesId){
      const me = this
      axios.get('terminals/listpost?business_id='+bussinesId)
        .then(function (responsePos){
          for(const item of responsePos.data){
            me.filter_pos.push({
              value: item._id, text: item.name
            })
          }
          me.getStock(false)
        })
    }, 

    getStock(isMore){
      const me = this
      let urlApi = ''
      let page = isMore ? this.currentPage + 1 : 1
    
      if(this.selected_filter_pos == "todos"){
        urlApi = 'stock/listByBusiness?id=' + this.businessId +
                '&page=' + page +
                '&limit=20' +
                '&search=' + this.currentSearch +
                '&startDate=' + this.dateStart +
                '&endDate=' + this.dateEnd  +
                '&type=' + this.select_filter_type 
      }else{
        urlApi = 'stock/listByPos?id=' + this.selected_filter_pos +
                '&page=' + page +
                '&limit=20' +
                '&search=' + this.currentSearch +
                '&startDate=' + this.dateStart +
                '&endDate=' + this.dateEnd  +
                '&type=' + this.select_filter_type 
      }
      axios.get(urlApi)
      .then(function (responseOrders){
        if(!isMore) me.stock = []
        me.totalPage = responseOrders.data.totalPages
        me.currentPage = responseOrders.data.currentPage
        console.log(responseOrders.data)
        for(const item of responseOrders.data.data){
          me.stock.push(item)
        }
        if(me.totalPage == me.currentPage) me.showBtnMore = false
        else me.showBtnMore = true
      } )
    },

    formattedDate(date){
      const fDate = this.dateHelpers.formatTable(date)
      return fDate;
    },
    formattedType(dataType){
      if(dataType === "in")
        return "Entrada"
      else return "Salida"
    },
    showItemInfo(item){
      this.$refs.drawerOrder.show(item);
    },

    exportExcel() {


      const me = this
      let dataStockExcel = []
      dataStockExcel.push(["CREADO","TIPO","SKU","PRODUCTO","UNIDADES","COSTO UNITARIO","TOTAL ($)", "POS", "NOTA"]);
      let filterApi = 'stock/listByBusiness?id=' + this.businessId

      if(this.selected_filter_pos != "todos"){
          filterApi = 'stock/listByPos?id=' + this.selected_filter_pos
      }

      const  urlApiExcel = filterApi +
        '&page=1' +
        '&limit=10000' +
        '&search=' + this.currentSearch +
        '&startDate=' + this.dateStart +
        '&endDate=' + this.dateEnd  +
        '&type=' + this.select_filter_type 

        
      
      axios.get(urlApiExcel)
      .then(async function  (response){
        
        for(const item of response.data.data){
          dataStockExcel.push(
          [
            me.formattedDate( item.createdAt),
            me.formattedType(item.type),
            item.product_sku,
            item.product_name,
            item.quantity,
             item.cost,
            item.quantity * item.cost,
            item.terminal_id.name, 
            item.note
          ])
        }

        const workbook = XLSX.utils.book_new();
        let name = me.dateStart+" al "+me.dateEnd;
        let data = XLSX.utils.aoa_to_sheet(dataStockExcel);
        const boockStock = "Stock";
        XLSX.utils.book_append_sheet(workbook, data, boockStock);    
        XLSX.writeFile(workbook, `Registros E/S ${name}.xlsx`);
      } )        
    },

  },
};
</script>

<style scoped lang="scss">
  @import './../assets/styles/sections-app.css';

  .btn-excel{
    margin-right: 20px;
    margin-top: 15px;
  }
</style>